import type { Extensions } from '@tiptap/core';
import { ConvertKit } from '@tiptap-pro/extension-convert-kit';

import { HeaderFooterVariableDecoration } from 'containers/Tiptap/lib/header-footer-variable-decoration';

// Image is `inline` so a logo rides its cell paragraph's text-align (the zone).
export const headerFooterExtensions: Extensions = [
  ConvertKit.configure({
    image: {
      inline: true,
      resize: {
        enabled: true,
        directions: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
        minWidth: 24,
        minHeight: 16,
        alwaysPreserveAspectRatio: true,
      },
    },
  }),
  HeaderFooterVariableDecoration,
];

// Tiptap has no native zoned header/footer API; their DOCX template uses a table.
export const HEADER_FOOTER_ZONE_HTML =
  '<table><tbody><tr>' +
  '<td><p style="text-align: left"></p></td>' +
  '<td><p style="text-align: right"></p></td>' +
  '</tr></tbody></table>';
